import React__default from 'react';
import { useFloatingLabelTextInputElement } from '../../contexts/internal/floating-label/index.js';
import { useSwanComboboxContext } from './combobox.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { className } from '../../../core/utilities/classnames.utils.js';
import { RenderComp } from '../core/render-comp.component.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const propTypes = {};
/**
 * @subcomponent Combobox
 */ const ComboboxInput = renderWithRef('ComboboxInput', propTypes, (props, ref)=>{
    const { inputRef, inputProps } = useSwanComboboxContext();
    const combinedRef = assignRefs(ref, inputRef);
    const filteredProps = useFloatingLabelTextInputElement(_object_spread_props(_object_spread({}, inputProps, props), {
        className: className(props.className, 'swan-input swan-combobox')
    })) // id will never be undefined since the react-aria code always sets it
    ;
    return /*#__PURE__*/ React__default.createElement(RenderComp, {
        forwardedRef: combinedRef,
        root: 'input',
        props: _object_spread_props(_object_spread({}, filteredProps), {
            type: 'text'
        })
    });
});

export { ComboboxInput };
